import { saveAs } from 'file-saver';
import { utils, write } from 'xlsx';

type SDKChartDataFields = Record<string, string>;
export interface SDKChartData {
  fields: SDKChartDataFields;
  documents: SDKChartDataFields[];
}

export const sortChartDataByCreatedAt = (chartData): void => {
  const createdAtFieldIndex = Object.values(chartData.fields).indexOf('createdAt');
  if (createdAtFieldIndex >= 0) {
    chartData.documents = chartData.documents.sort(
      (d1, d2) => (Object.values(d1)[createdAtFieldIndex] as Date).getTime() - (Object.values(d2)[createdAtFieldIndex] as Date).getTime(),
    );
  }
};

export const downloadChartDataAsExcel = (data: SDKChartData, fileName: string): void => {
  sortChartDataByCreatedAt(data);

  const excelData: string[][] = [];

  Object.values(data.fields).forEach((field) => {
    if (!excelData[0]) {
      excelData.push([]);
    }
    excelData[0].push(field);
  });

  data.documents.forEach((document, index) => {
    const rowIndex = index + 1;
    if (!excelData[rowIndex]) {
      excelData.push([]);
    }
    Object.keys(data.fields).forEach((col) => {
      excelData[rowIndex].push(document[col] || '');
    });
  });

  const ws = utils.json_to_sheet(excelData, { skipHeader: true });
  const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
  const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' });

  const exportData = new Blob([excelBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
  });

  saveAs(exportData, `${fileName}${generateTimestamp()}.xlsx`);
};

const generateTimestamp = (): string => {
  const now = new Date();
  const PADDING_LENGTH = 2;
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(PADDING_LENGTH, '0');
  const day = String(now.getDate()).padStart(PADDING_LENGTH, '0');
  const hours = String(now.getHours()).padStart(PADDING_LENGTH, '0');
  const minutes = String(now.getMinutes()).padStart(PADDING_LENGTH, '0');
  return `_${year}${month}${day}_${hours}${minutes}`;
};
